import { ProjectCard } from '@/components/projects/ProjectCard';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

const projects = [
  { year: '2007–2013', title: 'Lisewska Bezprzewodowa Sieć Informacyjna', category: 'Cyfryzacja' },
  { year: 'Cyklicznie', title: 'Jaszczur Music Festival', category: 'Kultura' },
  { year: 'Od 2016', title: 'Konkurs grantowy Działaj Lokalnie', category: 'Granty' },
  { year: 'XII co roku', title: 'Mikołajkowy Bieg Charytatywny', category: 'Sport' },
  { year: 'V 2024', title: 'Ulecz Duszę — zdrowie psychiczne', category: 'Zdrowie' },
  { year: 'XII 2024', title: 'Męska Moc w Lisewie', category: 'Integracja' },
];

const ProjectsSection = () => {
  const { data: saved = [] } = useQuery({
    queryKey: ['completed-projects'],
    queryFn: async () => {
      const { data, error } = await supabase.from('completed_projects').select('*').order('created_at', { ascending: false });
      if (error) throw error;
      return data ?? [];
    },
  });
  const visible = saved.length ? saved : projects.map(p => ({ ...p, year_period: p.year }));
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-10 text-center">Nasze projekty</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {visible.map((p, i) => (
            <ProjectCard key={i} project={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
